import {
  classLessonTimeSchema,
  curriculumTypeSchema,
  lessonCountPerMonthSchema,
  ticketLangTypeSchema,
  yesNoSchema,
} from '@server/schemas'
import { z } from 'zod'

/** 구독·체험 수강권에 저장되는 수업 언어. JP 시장의 한국어 수업은 KR을 사용한다. */
export const subscribeLessonLangTypeSchema = ticketLangTypeSchema

export const rawGetSubscribeMappListSchema = z.object({
  subscribe_mapp_id: z.string(),
  package_name: z.string(),
  ticket_start_date: z.string(),
  ticket_start_datetime: z.string().nullish(),
  ticket_expire_datetime: z.string().nullish(),
  lang_type_name: z.string(),
  reg_class_count: z.number(),
  payment_lang_type: subscribeLessonLangTypeSchema,
  remain_count: z.number(),
  origin_count: z.number(),
  subscribe_id: z.string(),
  subscribe_final_date: z.string(),
  lang_type: subscribeLessonLangTypeSchema,
  subscribe_start_date: z.string(),
  payment_type: z.string(),
  ticket_expire_date: z.string(),
  ticket_id: z.string(),
  is_trial_ticket: yesNoSchema,
  curriculum_type: curriculumTypeSchema,
  lesson_time: classLessonTimeSchema,
})

export type RawGetSubscribeMappList = z.infer<typeof rawGetSubscribeMappListSchema>

export const rawGetTicketSubscribeListSchema = z.object({
  subscribe_mapp_id: z.string(),
  subscribe_id: z.string(),
  ticket_ids: z.string(),
  name: z.string(),
  cur_payment_count: z.number(),
  total_payment_count: z.number(),
  lesson_count_per_month: lessonCountPerMonthSchema,
  start_date: z.string(),
  end_date: z.string(),
  next_payment_date: z.string().nullable(),
  next_payment_amount: z.number().nullable(),
  subscribe_type: z.string(),
  subscribe_status: z.string(),
})

export type RawGetTicketSubscribeList = z.infer<typeof rawGetTicketSubscribeListSchema>

export const ticketInfoSchema = z.object({
  subscribe_mapp_id: z.string().optional(),
  curriculum_type: curriculumTypeSchema,
  lang_type: subscribeLessonLangTypeSchema,
  lesson_time: classLessonTimeSchema,
  is_trial_ticket: yesNoSchema,
  remain_count: z.number().optional(),
  ticket_expire_date: z.string().optional(),
  ticket_start_date: z.string().optional(),
  ticket_start_datetime: z.string().nullish(),
  ticket_expire_datetime: z.string().nullish(),

  unlimit_yn: yesNoSchema.optional(),
  origin_count: z.union([z.number(), z.string()]).optional(),
  reg_class_count: z.number().optional(),
})

export type TicketInfo = z.infer<typeof ticketInfoSchema>

export const languageTicketSchema = z.object({
  langType: subscribeLessonLangTypeSchema,
  purchasedCount: z.union([z.number(), z.literal('unlimited')]),
  eventType: z.enum(['COUNT', 'UNLIMITED']),
  paymentLangType: subscribeLessonLangTypeSchema,
  displayName: z.string(),
})

export type LanguageTicket = z.infer<typeof languageTicketSchema>
